// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"51":"8aabde1b651277d72769","540":"4a5e7d896ffed954db83","543":"432beb67cc9bfbfc7b6e","648":"6751e53ee706e15be25e","676":"20b14c88e80233c9e881","924":"dab248c32d07aed7c38e","959":"ad9c511a660d99b9348f","961":"63e8d032feeb65c45b84"}[chunkId] + ".js";
};